import "../src/css/style.scss"
import { createApp } from 'vue';
import App from "./App.vue"; 

const app = createApp(App);
app.mount("#app");